const timezoneOptions = [
    'Eastern',
    'Central',
    'Mountain',
    'Pacific',
    'Alaska',
    'Hawaii'
].map(value => ({ key: value, value, text: value }));

export default timezoneOptions;
